import React from 'react'
import Couses from './Couses'
import CoursesNabbar from './CoursesNabbar'
import { BrowserRouter, Route,Routes } from 'react-router-dom'
import Computerscience from './class 10/Computerscience'
import Noteswritten from './Noteswritten'
import Footer from './Footer'
export default function Notes() {
  return (
   <>
     <div className='bg-slate-300 mt-5 pb-2 '>
    <Noteswritten></Noteswritten>
    </div>
    <div className='mt-2'>
    <CoursesNabbar></CoursesNabbar>
   

  </div>
    <div className='w-full'>
      <img className="w-full h-[50vh] object-cover" src='https://i0.wp.com/highschool.latimes.com/wp-content/uploads/2019/01/45692459364_2d91368a04_z.jpg?fit=640%2C427&ssl=1' alt='notes'></img>
      
    </div>
    
    
  <div className='mt-5'><Footer></Footer></div>

   </>
  )
}
